import _defineProperty from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";
import "core-js/modules/es6.regexp.replace";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";

var _actions;

import { isEmpty } from "lodash";
import * as types from "@/store/constants/types";
import router from "@/router/router";
import { routerGoBack, routerPush, routerReplace } from "@/utils/routerStackUtil";

var routerQueryFactory = function routerQueryFactory(payload) {
  if (payload.query && !isEmpty(payload.query)) {//将query的
    // for (const key of Object.keys(payload.query)) {
    //   if (isObject(payload.query[key])) {
    //     newQuery[key] = JSON.stringify(payload.query[key]);
    //   } else if (isString(payload.query[key])) {
    //     newQuery[key] = payload.query[key];
    //   } else if (isFunction(payload.query[key])) {
    //     newQuery[key] = payload.query[key].toString();
    //   } else {
    //     newQuery[key] = payload.query[key];
    //   }
    // }
    // payload.query = JSON.stringify(payload.query);
    // console.log("payload.query:", payload.query);
    // console.log("payload.query123123:", JSON.stringify(payload.query));
    // payload.query = {
    //   data: JSON.stringify(payload.query)
    // };
    //  = newQuery;
  }
};

var actions = (_actions = {}, _defineProperty(_actions, types.ROUTER_PUSH, function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(_ref, payload) {
    var state, commit, dispatch;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            state = _ref.state, commit = _ref.commit, dispatch = _ref.dispatch;
            _context.prev = 1;
            // console.log('router',router)
            routerQueryFactory(payload);
            _context.next = 5;
            return router.push(payload);

          case 5:
            // commit(types.ROUTER_PUSH, payload);
            routerPush(payload);
            _context.next = 10;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.ROUTER_GO_BACK, function () {
  var _ref4 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(_ref3, payload) {
    var state, commit, dispatch;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            state = _ref3.state, commit = _ref3.commit, dispatch = _ref3.dispatch;
            _context2.prev = 1;
            console.log("ROUTER_GO_BACK", payload);

            if (!(typeof payload === "number")) {
              _context2.next = 9;
              break;
            }

            _context2.next = 6;
            return router.go(payload);

          case 6:
            routerGoBack(payload);
            _context2.next = 13;
            break;

          case 9:
            if (!(typeof payload === "undefined")) {
              _context2.next = 13;
              break;
            }

            _context2.next = 12;
            return router.go(-1);

          case 12:
            routerGoBack(-1);

          case 13:
            _context2.next = 18;
            break;

          case 15:
            _context2.prev = 15;
            _context2.t0 = _context2["catch"](1);
            console.log("ROUTER_GO_BACK error:", _context2.t0);

          case 18:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 15]]);
  }));

  return function (_x3, _x4) {
    return _ref4.apply(this, arguments);
  };
}()), _defineProperty(_actions, types.ROUTER_REPLACE, function () {
  var _ref6 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3(_ref5, payload) {
    var state, commit, dispatch;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            state = _ref5.state, commit = _ref5.commit, dispatch = _ref5.dispatch;
            _context3.prev = 1;
            routerQueryFactory(payload);
            _context3.next = 5;
            return router.replace(payload);

          case 5:
            routerReplace(payload);
            _context3.next = 10;
            break;

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](1);

          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 8]]);
  }));

  return function (_x5, _x6) {
    return _ref6.apply(this, arguments);
  };
}()), _actions);
export default actions;